import i18n from '@/i18n';
import loadable from '@loadable/component';
//$IMPORT$

export default () => [
  {
    needLogin: true,
    resourceName: i18n.t('SystemMessage-index-1992f2b82030d1966-1'),
    routerUrl: '/SystemMessage',
    resourceIcon: 'TeamOutlined',
    type: '2',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./SystemMessage')),
    children: [
      {
        needLogin: true,
        resourceName: i18n.t('SystemMessage-index-1992f2b82030d1966-2'),
        routerUrl: '/SystemMessageForm',
        resourceIcon: '',
        type: '2',
        buttons: [],
        component: loadable(() => import('./SystemMessageForm')),
      },
      //$MORE$
    ],
  },
];
